import styled from "styled-components";

export const BaseStationStyle = styled.div`
  .heading-icon {
    color: #f28809;
  }

  .table-item {
    font-size: 1rem;
  }

  .table-loading {
    text-align: center;
  }

  .table-item2 {
    font-family: light-pro, sans-serif;
  }
  .table-div {
    padding: 20px;
    width: 80%;
    height: 270px;
    overflow-y: auto;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }

  .table-head {
    position: sticky;
    top: -20px;
    background: white;
  }

  /* For large devices */
  @media screen and (max-width: 1024px) {
    .table-item {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 1440px) {
    .table-item {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 500px) {
    .table-item {
      font-size: 0.5rem;
    }
  }
`;
